import React from 'react';
import { ChevronRight } from 'lucide-react';
import usePageData from '../helpers/usePageData';

const PolitiqueConfidentialite = () => {
    const { data: pageData, loading } = usePageData('politique-confidentialite');

    if (loading || !pageData) return null;

    return (
        <div className="politique-confidentialite">
            {/* Hero Section */}
            <section className="bg-dark text-white py-5">
                <div className="container py-5 text-center">
                    <h1 className="display-4 fw-bold mb-4">
                        {pageData.hero.title.includes('CONFIDENTIALITÉ') ? (
                            <>{pageData.hero.title.split('CONFIDENTIALITÉ')[0]}<span className="text-warning">CONFIDENTIALITÉ</span></>
                        ) : pageData.hero.title}
                    </h1>
                    <p className="fs-5 mx-auto" style={{ maxWidth: '800px' }}>
                        {pageData.hero.subtitle}
                    </p>
                </div>
            </section>

            {/* Main Content Section */}
            <section className="py-5 bg-white">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            {pageData.sections.map((section, index) => (
                                <div className="mb-5" key={index}>
                                    <h2 className="h3 fw-bold mb-3">{section.title}</h2>
                                    {section.content && (
                                        <p className="fs-5 text-muted mb-3">{section.content}</p>
                                    )}
                                    {section.list && (
                                        <ul className="fs-5 text-muted">
                                            {section.list.map((item, i) => (
                                                <li key={i}>{item}</li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            ))}

                            {/* Contact Button */}
                            <div className="text-center mt-5">
                                <a
                                    href={`mailto:${pageData.contactEmail}`}
                                    className="btn btn-warning btn-lg rounded-pill px-4 d-inline-flex align-items-center"
                                >
                                    {pageData.contactButtonText}
                                    <ChevronRight size={20} className="ms-2" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default PolitiqueConfidentialite;
